import * as fromDatatype from '../datatype-library/index';

export interface bl_sfa_deal_contact_hdr_link_RowInterface {
 
  guid: fromDatatype.GuidDataFieldInterface;
  deal_hdr_guid : fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid : fromDatatype.GuidDataFieldInterface;
  link_type : fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  name : fromDatatype.VarcharDatatypeInterface;
  code : fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface
  revision : fromDatatype.GuidDataFieldInterface
  vrsn : fromDatatype.VarcharDatatypeInterface;
}

export class bl_sfa_deal_contact_hdr_link_RowClass implements bl_sfa_deal_contact_hdr_link_RowInterface {

  guid: fromDatatype.GuidDataFieldInterface;
  deal_hdr_guid : fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid : fromDatatype.GuidDataFieldInterface;
  link_type : fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  name : fromDatatype.VarcharDatatypeInterface;
  code : fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface
  revision : fromDatatype.GuidDataFieldInterface
  vrsn : fromDatatype.VarcharDatatypeInterface;

}
